export default __webpack_public_path__ + "static/media/dapps2.415d81c1.jpg";